/* ==========================================================================
   HOPE BASE ADVISORY LLC — MAIN JS ENTRY (WITH SETTINGS & PUBLIC DOC ROUTER)
   ========================================================================== */

import '../styles/invoice.css';
import { initNavigation } from './navigation.js';
import { initHeroMatrix } from './hero-matrix.js';
import { initSectorTabs } from './sector-tabs.js';
import { initSomaliaMap } from './somalia-map.js';
import { initScrollAnimations } from './scroll-animations.js';
import { initProjectFilters } from './project-filters.js';
import { initConsultationModal } from './modal.js';
import { initThemeSwitcher } from './theme-switcher.js';
import { initAdminPortal } from './admin-portal.js';
import { initInvoiceMaker } from './invoice-maker.js';
import { initAdminSettings } from './admin-settings.js';
import { initPublicDocViewer } from './public-doc.js';
import { initMotionSuite } from './motion-suite.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavigation();
  initThemeSwitcher();
  initHeroMatrix();
  initSectorTabs();
  initSomaliaMap();
  initScrollAnimations();
  initMotionSuite();
  initProjectFilters();
  initConsultationModal();
  initAdminPortal();
  initInvoiceMaker();
  initAdminSettings();
  initPublicDocViewer();
});
